const stateSelector = (state) => state.depositAccountOnboarding;

export const selectDepositAccountOnboardingIsFetching = (state) => stateSelector(state).isFetching;
export const selectDepositAccountOnboardingIsError = (state) => stateSelector(state).isError;
export const selectDepositAccountOnboardingIsLoaded = (state) => stateSelector(state).isLoaded;
export const selectDepositAccountOnboardingLink= (state) => stateSelector(state).link;
